module.exports = __webpack_public_path__ + "media/1_1.a6c77fc5.wav";